export default __webpack_public_path__ + "static/media/cont11.d379e8d8.png";